export default __webpack_public_path__ + "static/media/healthcare-services-chart.a879c51b.jpeg";